// components/AudioUploader.js
import React, { useState } from "react";
import axios from "axios";

import UploadScreen from "./UploadScreen";
import LoadingScreen from "./LoadingScreen";
import ResultScreen from "./ResultScreen";

import "../styles/AudioUploader.css";

function AudioUploader() {
  const [file, setFile] = useState(null);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [result, setResult] = useState(null);
  const [stage, setStage] = useState("upload"); // upload | loading | result

  const handleRestart = () => {
    setFile(null);
    setResult(null);
    setStage("upload");
    setLoadingProgress(0);
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setResult(null);
    setStage("upload");
  };

  const handleUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("audio", file);
    setStage("loading");

    const simulateProgress = () => {
      let progress = 0;
      const interval = setInterval(() => {
        progress += 2 + Math.random() * 5;
        if (progress >= 100) {
          progress = 100;
          clearInterval(interval);
        }
        setLoadingProgress(Math.floor(progress));
      }, 150);
    };

    simulateProgress();

    try {
      const res = await axios.post('https://audio-split-backend.onrender.com/separate', formData);
      setResult(res.data);
      setStage("result");
    } catch (error) {
      console.error("Erro ao enviar o áudio:", error);
      setStage("upload");
    }
  };

  return (
    <div className="audio-uploader">
      {stage === "upload" && (
        <UploadScreen
          onFileChange={handleFileChange}
          onUpload={handleUpload}
          file={file}
        />
      )}
      {stage === "loading" && <LoadingScreen progress={loadingProgress} />}
      {stage === "result" && result && (
        <ResultScreen
          result={result}
          originalName={file?.name.replace(/\.[^/.]+$/, "")}
          onRestart={handleRestart}
        />
      )}
    </div>
  );
}

export default AudioUploader;
